import firebase from "firebase/compat/app";

export const getCurrentUserEmail = () => {
  const user = firebase.auth().currentUser;
  if (user) {
    return user.email;
  }
  return "";
};
